const arrayModes = ["multiple", "tags"]
const supportedModes = [...arrayModes]

export { arrayModes, supportedModes }
